import { useReportEffect } from "../../../../hooks/useReportEffect";
import { useMemo, useState } from "react";
import { useFilter } from "../../../../hooks/useFilter";
import { flattenSelection, selectionToSortedIdsKey, useFilterContextV2 } from "../../../../contexts/FilterContextV2";
import "../styles.css";
import { useTranslation } from "react-i18next";

export function InfoBatches() {
	const { t } = useTranslation();
	const { batchCategory } = useFilter();
	const { selectedFarms, selectedAreas } = useFilterContextV2();

	const farmsKey = useMemo(
		() => selectionToSortedIdsKey(selectedFarms),
		[selectedFarms],
	);
	const areasKey = useMemo(
		() => selectionToSortedIdsKey(selectedAreas),
		[selectedAreas],
	);

	const [adjustments, setAdjustments] = useState<number | null>(null);
	const balanceTotal = useMemo(
		() => batchCategory
			? batchCategory.content.reduce(
					(sum, batch) =>
						sum +
						batch.categories.reduce(
							(batchSum, category) => batchSum + category.quantity,
							0,
						),
					0,
				)
			: null,
		[batchCategory],
	);

  useReportEffect((axios) => {
    const farms = flattenSelection(selectedFarms);
    const areas = flattenSelection(selectedAreas);
    if (!farms.length || !areas.length) { setAdjustments(null); return; }
    const controller = new AbortController();
    Promise.all(farms.map(farm => {
      const areaIds = areas.filter(area => String(area.info?.farm?.id) === String(farm.value)).map(area => Number(area.value));
      if (!areaIds.length) return Promise.resolve({ data: [] });
      return axios.get(`/adjustments?farmId=${farm.value}&areaIds=${areaIds}`, { signal: controller.signal });
    })).then(responses => setAdjustments(responses.reduce((sum, response) => sum + response.data.reduce((total: number, adjustment: { balance: number }) => total + adjustment.balance, 0), 0)))
      .catch(() => undefined);
    return () => controller.abort();
  }, [farmsKey, areasKey]);

	return (
		<section className="dashBoardInfo__container" style={{ marginTop: 30 }}>
			<div className="dashBoardInfoSplited__owner--container">
				<small>{t("dashboardUi.currentAdjustment")}</small>
				<h6
					className={
						adjustments && adjustments <= 0
							? "dashBoardAdjustment__negative"
							: "dashBoardAdjustment__positive"
					}
				>
					{adjustments ?? "—"}
				</h6>
			</div>

			<div className="dashBoardInfo__dark--container">
				<small>{t("dashboardUi.expectedBalance")}</small>
				<h6>
					{balanceTotal == null || adjustments == null
						? "—"
						: balanceTotal - adjustments}
				</h6>
			</div>
		</section>
	);
}
